export default {
  name: "语言",
  selection: "系统语言选择",
  native: {
    english: "英文",
    simplified_chinese: "中文 （简体）",
    traditional_chinese: "中文 （繁体）",
    vietnamese: "越南文",
    thai: "泰文",
    indonesian: "印度尼西亚文",
    malay: "马来文",
    japanese: "日文",
    korean: "韩文"
  }
};
